enum AccionesFuncionalidad {
  buscar_solicitudes = 1,
  limpiar_datos = 2,
  crear_expediente = 3,
  ver_expediente = 4,
  rechazar_expediente = 5,
  solicitar_antecedentes = 6,
  aprobar_expediente = 7,
  solicitar_prorroga = 8,
  aprobar_prorroga = 9,
  ver_antecedentes = 10,
  ingresar_antecedentes = 11,
  enviar_antecedentes = 12,
  rechazar_prorroga = 13,
  ver_historial = 14,
  firmar_resolucion = 15,
  cerrar_expediente = 16,
  validar_documento = 17,
  aprobar_apelacion = 18,
  rechazar_apelacion = 19,
  ver_apelacion = 20,
  solicitar_apelacion = 21,
  ver_plantillas_documentos = 22,
  ver_documento = 23,
  reemplazar_documento = 24,
  ver_prorroga = 25
}

export default AccionesFuncionalidad;